<template>
  <div>
    <b-modal :id="`bv-modal-cancel-order`" size="lg" hide-footer>
      <template #modal-title>Cancel order</template>

    <div class="alert alert-danger py-2 mb-1 text-center" role="alert">Are you sure you want to cancel this order?</div>

        <div v-if="item" class="mt-3">
            <div class="text-center">
                <div>
                  <img v-if="item.product.images.length > 0" :src="item.product.images[0].url" style="height:4rem;" />
                  <img v-else src="/images/image-not-found.svg" style="height:4rem;" />
                </div>
            </div>   
        </div>

      <div class="row text-center">
        <div class="col">
            <div class="mt-2"><b>{{item.product.name}}</b></div>
            <div>R {{item.product.price*item.quantity}} &bull; Qty {{item.quantity}}</div>
        </div>
      </div>

      <div class="row mt-3 pb-2">
        <div class="col mt-2 mt-md-0">
            <button type="button" class="btn btn-secondary submit col" @click="hideModalCancelOrder">Go back</button>
        </div>
        <div class="col mt-2 mt-md-0">
            <button v-if="updating" type="button" class="btn btn-danger submit col">
            <i class="fas fa-spinner fa-sm fa-spin mr-2 move-up"></i></button>
            <button v-else type="button" class="btn btn-danger submit col" @click="cancelOrder">Cancel order</button>
        </div>
      </div>
    </b-modal>
  </div>
</template> 

<script>
export default {
props: ['item'],
  data() {
    return {
      address: {},
      updating: false,
      reason: 'Supplier out of stock',
    };
  },

  methods: {

    hideModalCancelOrder() {
      this.$bvModal.hide('bv-modal-cancel-order');
    },

    cancelOrder() {

      if (!this.reason) { this.sweetfire('Please select a reason'); }
      
      else {

          this.updating = true;

          axios.post('/dashboard/cancel', {item: this.item, reason: this.reason})
            .then((response) => {

        if (response.data.success) {
                this.$emit('update-page');
                this.successAlert(response.data.message);
                this.hideModalCancelOrder();
            } else {
                this.sweetfire(response.data.message);
            }

          this.updating = false;

        });
      }

    },

      // sweet alert for 3 seconds
      successAlert(text) {

        Swal.fire({
            title: text,
            customClass: {
                title: "popup-title",
                icon: 'custom-icon-size'
            },
            icon: 'success',
            showConfirmButton: false,
            timer: 3000,
            });
      },

      sweetfire(text) {

      Swal.fire({
      title: text,
      showConfirmButton: false,
      showDenyButton: false,
      showCancelButton: true,
      focusConfirm: false,
      cancelButtonText: 'Ok',
      customClass: {
              title: "popup-title",
            },
    })

    },
  },
};
</script>

<style scoped>
textarea.form-control { font-size: 0.9rem !important; }
</style>